import { compose } from 'ramda'

import { pathJoin } from 'shared/utils'
import { pickData, SuccessResponse } from 'shared/request'
import { apiHttp } from 'shared/request'
import { convertToNftDetail, convertToNftItem, NftDetailDto, NftItemDto } from '../DTO'

import type { NftDetail, NftFormData } from 'core/nft/models'

const URI = '/nft'

export const getList = (account: string) => {
    const url = pathJoin(URI)
    return apiHttp
        .get<SuccessResponse<NftItemDto[]>>(url, { account, chain: 1 })
        .then(pickData)
        .then(value => {
            return value.map(item => convertToNftItem(item))
        })
}

export const getDetail = (id: NftDetail['id']) => {
    const url = pathJoin(URI, id)
    return apiHttp.get<SuccessResponse<NftDetailDto>>(url).then(compose(convertToNftDetail, pickData))
}

export const syncData = (token_address: string, token_id: string) => {
    const url = pathJoin(URI, 'sync')
    return apiHttp.post<SuccessResponse<void>>(url, { token_address, token_id }).then(pickData)
}

export const edit = (formData: NftFormData) => {
    const url = pathJoin(URI, 'edit')
    return apiHttp.put<SuccessResponse<void>>(url, { ...formData })
}
